import seqStore from "../../store/seqStore"

export default function Mute({ track }) {
    const solo = seqStore((state) => state.settings.solo)
    const mute = seqStore((state) => state.settings.mute)
    const setMute = seqStore((state) => state.setMute)
    const setSolo = seqStore((state) => state.setSolo)

    const handleSolo = () => {
        
        if (!solo[track]) {
            setSolo(track, true)
            setMute(track, false)
            for (let i = 0; i < 4; i ++) {
                if (i !== track) {
                    setSolo(i, false)
                    setMute(i, true)
                }
            }
        } else {
            setSolo(track, false)
            for (let j = 0; j < 4; j ++) {
                setMute(j, false)
            }
        }
    }

    return (
        <div className={solo[track]? `soloOn_${track}` : 'soloOff'} id={`solo_${track}`} onClick={handleSolo}><span>S</span></div>
    )
}
